
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/docs/komodo-defi-framework/api/legacy/set_required_confirmations",
      function () {
        return require("private-next-pages/en/docs/komodo-defi-framework/api/legacy/set_required_confirmations/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/docs/komodo-defi-framework/api/legacy/set_required_confirmations"])
      });
    }
  